import type { AsyncSequence } from "../types/AsyncSequence"
import type { GUID } from "../types/GUID"

import { MapAsync } from "../async/MapAsync"
import { NumberToUint8 } from "../bytes/NumberToUint8"
import { UInt8Hash } from "./UInt8Hash"

/**
 * Computes SHA-256 hash of a stream of numbers.
 *
 * Converts each number to bytes and computes a deterministic hash.
 *
 * @param stream - Async sequence of numbers
 * @returns Promise resolving to GUID hash
 *
 * @example
 * ```ts
 * import { NumberHash } from "@pdfking/tfunc"
 *
 * const hash = await NumberHash([1, 2, 3])
 * ```
 */
export const NumberHash = async (
  stream: AsyncSequence<number>
): Promise<GUID> => await UInt8Hash(MapAsync(NumberToUint8, stream))
